import { useEffect, useState } from 'react';

export const useMobile = (breakpoint: number = 767): boolean => {
    const [isMobile, setIsMobile] = useState<boolean>(
        window.matchMedia(`(max-width: ${breakpoint}px)`).matches
    );

    useEffect(() => {
        const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);
        const handleResize = (e: MediaQueryListEvent) => {
            setIsMobile(e.matches);
        };

        mediaQuery.addEventListener("change", handleResize);
        return () => {
            mediaQuery.removeEventListener("change", handleResize);
        };
    }, [breakpoint]);

    return isMobile;
};

export const useTablet = (minBreakpoint: number = 768, maxBreakpoint: number = 1023): boolean => {
    const [isTablet, setIsTablet] = useState<boolean>(
        window.matchMedia(`(min-width: ${minBreakpoint}px) and (max-width: ${maxBreakpoint}px)`).matches
    );

    useEffect(() => {
        const mediaQuery = window.matchMedia(`(min-width: ${minBreakpoint}px) and (max-width: ${maxBreakpoint}px)`);
        const handleResize = (e: MediaQueryListEvent) => {
            setIsTablet(e.matches);
        };

        mediaQuery.addEventListener("change", handleResize);
        return () => {
            mediaQuery.removeEventListener("change", handleResize);
        };
    }, [minBreakpoint, maxBreakpoint]);

    return isTablet;
};
